import { initializeAnalytics } from '../../utils/analytics/loginAnalytics';


/**
 * Initialize analytics tracking
 * @param {App} [app]
 * @return {Promise}
 */
export default function setup() {
  initializeAnalytics();
  return Promise.resolve(true);
}
